import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from '@wz-constants';
import { environment } from '@wz-environments';
import { LoadingService, LoggerService } from '@wz-services';
import { saveAs } from 'file-saver';

@Component({
  selector: 'wz-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss'],
  standalone: false,
})
export class FilePathManagerComponent implements OnInit {
  env: string = 'prod';
  path: string = 'prod';
  loadingDownload: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private loadingService: LoadingService,
    private loggerService: LoggerService,
  ) {}

  getInfoFIleFromRoute() {
    this.env = (this.route.snapshot.queryParams as any).env;
    this.path = (this.route.snapshot.queryParams as any).path;
  }

  getLoadingState() {
    return this.loadingService.loadingSubject.value;
  }

  async ngOnInit() {
    let re: any = this.router;
    this.loggerService.log(re);
    this.env = (this.route.snapshot.queryParams as any).env;
    this.path = (this.route.snapshot.queryParams as any).path;

    this.getInfoFIleFromRoute();

    await this.downloadFile(this.env, this.path);
  }

  async downloadFile(env: string, path: string) {
    const fileUrl =
      environment.urlBack + '/fileMTX/getFiles/' + env + '' + path;

    localStorage.setItem('fileURLMTX', fileUrl);

    await this.doDownload(fileUrl);
  }

  async getFileDownload(event: any) {
    let fileUrl = localStorage.getItem('fileURLMTX') ?? '';
    await this.doDownload(fileUrl);
  }

  async doDownload(fileUrl: string) {
    let mimetype = this.getMimeType(fileUrl) || 'application/pdf';

    this.loadingDownload = true;

    let response: any = await this.http
      .get(fileUrl, { responseType: 'blob' })
      .toPromise();
    const blob = new Blob([response], { type: mimetype });
    const filename = this.getFileNameFromURL(fileUrl);

    saveAs(blob, filename);

    this.loadingDownload = false;

    this.loadingService.loadingSubject.next(false);
  }

  getMimeType(url: string) {
    let filename = url.substring(url.lastIndexOf('/') + 1);
    let extension = filename
      ?.split('.')
      .pop() as keyof typeof AppConstants.MIMEType;
    return AppConstants.MIMEType[extension];
  }

  getFileNameFromURL(url: string) {
    const pathname = new URL(url).pathname;
    const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
    return fileName;
  }
}
